import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import * as Cookie from 'js-cookie';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isPWA } from '../utils/isPWA';
export const COOKIE_NAME = 'pwai';
export function usePWAInstallBanner() {
    const isPWAFlagEnabled = useFlag('pwa'); // for PWA in general
    const isFlagEnabled = useFlag('pwa_banners'); // specifically for these banners
    const { isLoggedIn } = useContext(SessionContext);
    const [installPrompt, setInstallPrompt] = useState(null);
    const isMobile = useContext(MobileContext);
    const cookieValue = Cookie.get(COOKIE_NAME);
    const [isDismissed, setIsDismissed] = useState(true);
    const isStandalone = useMemo(()=>isPWA(), []);
    const isHidden = !isLoggedIn || !isMobile || !isPWAFlagEnabled || !isFlagEnabled || isStandalone || isDismissed;
    // dismiss banner for 30 days
    const dismiss = useCallback(()=>{
        Cookie.set(COOKIE_NAME, '1', {
            expires: 30
        });
        setIsDismissed(true);
    }, []);
    useEffect(()=>{
        if (cookieValue !== '1') {
            setIsDismissed(false);
        }
        const ready = (e)=>{
            e.preventDefault();
            setInstallPrompt(e);
        };
        window.addEventListener('beforeinstallprompt', ready);
        return ()=>{
            window.removeEventListener('beforeinstallprompt', ready);
        };
    }, [
        isHidden,
        cookieValue
    ]);
    const handleInstall = async ()=>{
        if (!installPrompt) {
            return;
        }
        installPrompt.prompt();
    };
    return {
        isHidden,
        dismiss,
        installPrompt,
        onInstall: handleInstall
    };
}

//# sourceMappingURL=usePWAInstallBanner.js.map